import { connectFela } from '../../../dependencies';
import OpenModalButton from './OpenModalButton';
import * as styles from './OpenModalButton.styles';

export default connectFela(styles)(OpenModalButton);
